
import { Contact } from "@/models/base";
import Vue from "vue";
export default Vue.extend({
	props: {
		contact: {
			type: Object as () => Contact,
			required: true
		}
	},
	computed: {
		companyName():string {
			if (this.contact.MainAddress) {
				if (this.contact.MainAddress.CompanyName) {
					return this.contact.MainAddress.CompanyName;
				}
			}
			return "";
		}
	},
	i18nEx: {
		componentPrefix: "components.sales"
	}
});
